export default function ServiceCard({ service, index }) {
  return (
    <article className="service-card bits-spotlight" id={service.id}>
      <img loading="lazy" decoding="async" src={service.image} alt={service.name} />
      <div className="service-card-body">
        <span>{String(index + 1).padStart(2, "0")}</span>
        <h3>{service.name}</h3>
        <strong>{service.tagline}</strong>
        <p>{service.desc}</p>
        <ul>
          {service.treatments.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </div>
    </article>
  );
}
